<!--基本信息录入-->
<template>
   <div class="contentRight">
      <div class="inputList">
         <el-form ref="inputForm" :model="form" label-width="180px" label-suffix=":">
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="成果名称" prop="achieve_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.achieve_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="类别" prop="cate"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.cate" filterable remote reserve-keyword
                             placeholder="请选择推荐单位"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.cate" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="专业分类" prop="major_cate"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.major_cate"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="专业领域" prop="professional_field"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.professional_field" filterable remote reserve-keyword
                             placeholder="请选择专业领域"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.professional_field" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="应用部位" prop="apply_posi"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.apply_posi"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="技术创新开始时间" prop="start_time"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-date-picker style="width: 100%" v-model="form.start_time" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="完成整体技术应用时间" prop="complete_time"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-date-picker style="width: 100%" v-model="form.complete_time" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="申报单位" prop="company_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.company_name" :disabled="true"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="联系人" prop="linkman"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.linkman"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="电话" prop="link_phone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.link_phone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="手机" prop="cellphone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.cellphone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="通讯地址" prop="address"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.address"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="邮编" prop="zcode"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.zcode"/>
               </el-form-item>
            </el-col>
         </el-form>
      </div>
      <div class="uploadBtn" v-if="isEdit" style="margin-top: 5px; margin-bottom: 5px;">
         <el-button type="primary" @click="_saveData">保存</el-button>
      </div>
   </div>
</template>

<script>
   import {
      getApplyBasicInfo,
      postApplyBasicInfo
   } from "@/api/modules/techAchieveApply";
   import {getCompanyInfoByLoginUser} from '@/api/modules/project'
   import labelInput from '@/components/table/labelInput.vue'
   import labelSelect from "@/components/table/labelSelect";
   import ruiTool from "@/utils/ruiTool";
   import {vaildte} from "@/utils/validate";

   export default {
      data() {
         return {
            form: {
               opMode: '',
               project_application_id: '',
               id: '',
               achieve_name: '',
               cate: '',
               major_cate: '',
               apply_posi: '',
               start_time: '',
               complete_time: '',
               company_name: '',
               linkman: '',
               link_phone: '',
               cellphone: '',
               address: '',
               zcode: '',
               professional_field: '',
            },
            ddl: {
               /*类别*/
               cate: [{value: '房屋建筑工程', text: '房屋建筑工程'},
                  {value: '土木工程', text: '土木工程'},
                  {value: '工业安装工程', text: '工业安装工程'}],
               professional_field: [{value: '房修', text: '房修'},
                  {value: '市政', text: '市政'},
                  {value: '路桥', text: '路桥'},]
            }
         }
      },
      computed: {
         isEdit() {
            return this.form.opMode == 'edit';
         }
      },
      components: {
         labelInput,
         labelSelect
      },
      mounted() {
         //获取保存的传入参数
         this.form.project_application_id = localStorage.getItem("prjApplyCode")
         this.form.project_code = localStorage.getItem("prjCode");
         this.form.opMode = localStorage.getItem("opMode");

         //获取登录企业编号
         this.form.loginName = localStorage.getItem('loginName');
         this.form.company_code = localStorage.getItem('company_code');

         if (ruiTool.isNull(this.form.project_application_id)) {
            //新增模式
            this._getCompanyInfo();
         } else {
            //修改模式，展示原数据
            getApplyBasicInfo({
               data: {prjApplyID: this.form.project_application_id},
               success: (res) => {
                  //数据赋值
                  Object.keys(res.data.item).forEach((key) => {
                     this.form[key] = res.data.item[key]
                  })
               }
            })
         }
      },
      methods: {
         /*提交基本数据*/
         _saveData() {
            this.$refs['inputForm'].validate((valid) => {
               if (valid) {
                  postApplyBasicInfo({
                     data: this.form,
                     success: (res) => {
                        Object.keys(res.data.item).forEach((key) => {
                           this.form[key] = res.data.item[key];
                        })
                        //将当前申报项目编号保存到本地存储
                        localStorage.setItem("prjApplyCode", this.form.project_application_id);
                        this.$message.success("保存成功");
                     }
                  })
               } else {
                  this.$message.error("存在未填写项");
               }
            })
         },
         /*根据登录账号获取企业默认信息*/
         async _getCompanyInfo() {
            let param = {loginUser: localStorage.getItem('loginName')};
            await getCompanyInfoByLoginUser({
               data: param,
               success: (res) => {
                  console.log(res.data);
                  //默认数据赋值 -- 承建单位名称
                  this.form.company_name = res.data.item.name;
               }
            })
         },
         /*接收输入*/
         labelInput(e, name) {
            this.form[name] = e
         },
      }
   }
</script>

<style scoped>
   .contentRight {
      width: 100%;
   }

   /* 上传样式 */
   .inputList {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
   }
</style>